const makeItem = data => ({ label, id }) => ({
  id,
  label,
  items: data[id] || []
});

export const generateFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'location', label: 'locations' }),
    Item({ id: 'job_function', label: 'job function' }),
    Item({ id: 'experiences', label: 'experiences' }),
    Item({ id: 'employment_type', label: 'employment type' }),
    Item({ id: 'industry', label: 'industry' })
  ];
};

export const generateCandidateFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'main_theme', label: 'Vertical' }),
    Item({ id: 'sub_theme', label: 'Category' }),
    Item({ id: 'focus', label: 'Focus' }),
    ...generateFilters(data),
    Item({ id: 'company_size', label: 'Company Size' })
  ];
};
export const generateLearningFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'main_theme', label: 'Category' }),
    Item({ id: 'sub_theme', label: 'Subcategory' }),
    Item({ id: 'language', label: 'Language' })
  ];
};
export const generateMagazineFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'industry', label: 'Industry' }),
    Item({ id: 'employees_count', label: 'Employees Count' }),
    Item({ id: 'location', label: 'location' })
  ];
};
export const generateFreelancersRolesFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'main_themes', label: 'Vertical' }),
    Item({ id: 'owned_by', label: 'Owned by' }),
    Item({ id: 'sub_themes', label: 'Category' }),
    Item({ id: 'experiences', label: 'Experiences' }),
    Item({ id: 'industries', label: 'Industry' }),
    Item({ id: 'locations', label: 'location' })
  ];
};
export const generateFreelancersJobesFilters = (data = {}) => {
  const Item = makeItem(data);

  return [
    Item({ id: 'company_names', label: 'Company' }),
    Item({ id: 'owned_by', label: 'Owned by' }),
    Item({ id: 'main_themes', label: 'Vertical' }),
    Item({ id: 'sub_themes', label: 'Category' }),
    Item({ id: 'experiences', label: 'Experiences' }),
    Item({ id: 'industries', label: 'Industry' }),
    Item({ id: 'locations', label: 'location' })
  ];
};
